import script from "./LogoutButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoutButton.vue?vue&type=script&setup=true&lang=js"

import "./LogoutButton.vue?vue&type=style&index=0&id=51373af2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51373af2"]])

export default __exports__